import {person} from './personDef'
import {basic} from 'basic'
import {tree} from '../genealogy'
import {showError} from 'tree/treeProvider'
import React,{useState,useContext} from 'react'
import {wrMsg} from 'utile'
import {Langue} from 'context'

function Person(props:person.props)
{
    const [className,style]=basic.getBasic(props)
    const seeError=useContext(showError)
    const langue=useContext(Langue)
   
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        props.onChange({...props.value,[name]: value})
      //  setFormData((prev) => ({ ...prev, [name]: value }));
    };
    
    const {name,firstName}=props.value
    let erreurNom=""
    if(props.value.erreur=="nom" && seeError)
        erreurNom="erreurGen"
    let erreurPrenom=""
    if(props.value.erreur=="prenom" && seeError)
        erreurPrenom="erreurGen"

    return <div className={`${className} gperson`} style={{...style}} onBlur={props.onLoseFocus}>
                <input 
                    className={erreurPrenom}
                    type="text" 
                    id="prenom" 
                    name="firstName" 
                    value={firstName} 
                    onChange={handleChange} 
                    placeholder={wrMsg("Prénom","First name",langue)}
                />
                <input 
                    className={`${erreurNom}`}
                    type="text" 
                    id="nom" 
                    name="name" 
                    value={name} 
                    onChange={handleChange} 
                    placeholder={wrMsg("Nom","Last name",langue)}
                />

             
                
           </div>
}

export default React.memo(Person)